import type { Components, Theme } from "@mui/material";

export const MuiDialogTitle: Components<Theme>["MuiDialogTitle"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(2, 3, 2, 3), // top, right, bottom, left
    }),
  },
};
